<template>
    <div v-if='renderData'>
        <div v-for="(item,index) in renderData" :key="index" >
            <div class='subTitle'>{{item.theme}}</div>
            <div class='tabBox'>
                <div v-for="(innerItem,index) in item.data" :key="index" >
                    <div class='tabInner' @click="openList(innerItem.key)">
                        <p class='innerTxt'>{{innerItem.value}}</p>
                        <img src='https://p4-ky.wsukwai.com/udata/pkg/kmovie/img/info_arrow_new.png' class='innerImg'/>
                        <div class='line' v-show='item.data.length >1 && index !== item.data.length-1'></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ItemTab",
    props: {
        renderData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
        }
    },
    created(){
        
    },
    methods: {
        openList(key){
            this.$router.push({
                path: '/list',
                query: {
                    type: key
                }
            });
        }
    },
};
</script>

<style lang="less" scoped>
.subTitle{
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.26rem;
    color: #FFFFFF;
    opacity: 0.4;
    margin: 0.4rem 0 0.24rem 0.1rem;
}
.tabBox{
    width: '100%';
    background: #222222;
    mix-blend-mode: normal;
    border-radius: 0.24rem;
}
.tabInner{
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.32rem;
    height: 1.28rem;
    overflow: hidden;
    .innerTxt{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 0.30rem;
        text-align: justify;
        color: #FFFFFF;
    }
    .innerImg{
        width: 0.144rem;
        opacity: 0.3;
    }
    .line{
        position: absolute;
        bottom: 0;
        height: 0.01rem;
        width: 100rem;
        background-color: rgba(255, 255, 255, 0.06);
    }
}
</style>
